// extracted by mini-css-extract-plugin
module.exports = {"videoPage":"styles-module--videoPage--2f1o0","video":"styles-module--video--3BDPR"};